const headerData = [
  {
    prop: 'selection',
    label: '多选',
    types: 'selection',
    fixed: true,
    columnwidth: '50'
  },
  {
    prop: 'InvClassName',
    label: '产品线',
    types: 'String',
    columnwidth: '150',
    fixed: true
  },
  {
    prop: 'TOName',
    label: '院区/科室',
    types: 'String',
    columnwidth: '200'
  },
  {
    prop: 'HospitalName',
    label: '医院',
    types: 'String',
  },
  {
    prop: 'TOTypeName',
    label: '类型',
    types: 'String',
    columnwidth: '150'
  },
  {
    prop: 'Doctor',
    label: '术者',
    types: 'String',
    columnwidth: '150'
  },
  {
    prop: 'CreatorName',
    label: '创建人',
    types: 'String',
    columnwidth: '150'
  },
  {
    prop: 'CreateTime',
    label: '创建日期',
    types: 'String',
    columnwidth: '150'
  }
];
export default headerData;
